import { useAuthContext } from "../../hooks/useAuthContext";
import { useFirestore } from "../../hooks/useFirestore";
import { useCollection } from "../../hooks/useCollection";
import ProfileForm from "../../components/ProfileForm";
import { useNavigate } from "react-router-dom";

const EditProfile = () => {
  const { user } = useAuthContext();
  const { updateDocument, isPending, error } = useFirestore("users");
  const navigate = useNavigate();

  // Fetch user document from "users" collection where uid == user.uid
  const { documents, error: fetchError } = useCollection("users", {
    field: "uid",
    operator: "==",
    value: user.uid,
  });

  const userData = documents?.[0]; // Get the first matching document

  // Wait for user data
  if (!userData) {
    return <p className="text-light">Loading profile...</p>;
  }

  const initialData = {
    name: userData.name || "",
    email: user.email || "",
    phone: userData.phone || "",
    country: userData.country || "",
    city: userData.city || "",
    aboutMe: userData.aboutMe || "",
    photoURL: userData.photoURL || user.photoURL || "",
    github: userData.github || "",
    linkedin: userData.linkedin || "",
  };

  const handleSubmit = async (formData) => {
    await updateDocument(userData.id, formData); // update using document ID from Firestore
    navigate("/");
  };

  return (
    <div className="container-fluid py-5 bg-dark text-light min-vh-100">
      <div className="col-md-8 col-lg-6 mx-auto">
        <div className="card bg-danger text-light shadow">
          <div className="card-body">
            <h2 className="card-title mb-4">Edit Profile</h2>
            <ProfileForm
              onSubmit={handleSubmit}
              isPending={isPending}
              error={error || fetchError}
              show={false} // Hide name/password if needed
              currentImage={initialData.photoURL}
              initialValues={initialData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
